import { PagingResultsViewModel, FilterSearchingBaseViewModel, EnumSiNoTodos } from "../../../core/_infrastructure/types/common";


export class CpeItemResultsViewModel extends PagingResultsViewModel {

    public ResultList: CpeItemViewModel[];
}

export class CpeItemViewModel {

    public Id: number;
    public Codigo: string;
    public NumeroCertificado: string;
    public UsuarioSolicitante: string;
    public ComunidadAutonoma: string;
    public FechaEnvio: Date | null;
    public FechaEmision: Date | null;
    public FechaRechazo: Date | null;
    //public HoraEnvio: string;
    public EstadoCpe: string;
    public NombreOperadorCpe: string;
    public CodigoPostalOperadorCpe: string;
    public LocalidadOperadorCpe: string;
    //public ProvinciaOperadorCpe: string;
    public UsuarioCa: string;
    public IdEstadoCpe: number;
    public EsVisibleEdicion: boolean;
}

export class FilterSearchingCpeViewModel extends FilterSearchingBaseViewModel {

    firstDayMonth: Date;
    lastDayMonth: Date;

    constructor() {

        super();

        this.firstDayMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        let temp = new Date().getMonth() + 1;
        this.lastDayMonth = new Date(new Date(new Date().getFullYear(), temp, 1).getTime() - (0.001 * 60 * 60 * 24));

        this.FechaRegistroDesde = this.firstDayMonth;
        this.FechaRegistroHasta = this.lastDayMonth;
    }

    public Codigo: string = '';
    public NumeroCertificado: string = '';
    public NombreOperadorCpe: string = '';
    public UsuarioSolicitante: string = '';
    public FechaRegistroDesde: Date | null ;
    public FechaRegistroHasta: Date | null ;
    public IdEstadoCpe: number | null;
    public IdComunidadAutonoma: number | null;
    //public IdProvinciaOperadorCpe: number | null;
    public IdUsuario: number = 0;    
    
    //public EsInspector: boolean;
    //public EsCoordinador: boolean;
    public EsSolicitante: boolean;
    public EsComunidadAutonoma: boolean;
}











